module.exports = __webpack_public_path__ + "static/media/blog-3.60a5923f.jpeg";